import { connect } from 'react-redux';
import { StoreState } from '../../../../reducers';

import SpreadsSelector from '../../../../components/Editor/CombinePanel/SpreadsSelector';

const mapStateToProps = (state: StoreState) => {
	const {
		editor: {
			combo: {
				externalPublication: {
					isLoading,
					spreads,
					selection: { spreadIndices: selectedSpreadIndices },
				},
				isCombining,
			},
		},
	} = state;

	return {
		isLoading,
		isCombining,
		spreads,
		selectedSpreadIndices,
		isSelectedAll: selectedSpreadIndices.length > 0 && spreads.length === selectedSpreadIndices.length,
	};
};

export default connect(mapStateToProps)(SpreadsSelector);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/Editor/CombinePanel/SpreadsSelector/index.tsx